import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { useServerApi } from "../hooks/userServerApi";
import { normalizeNonWrapUpfrontFeeRules } from "../helpers/investmentTransactionSettingsUtils";
import { normalizeCommissionRateSettings } from "../helpers/investmentTransactionCommissionUtils";

const DEFAULT_SETTINGS = {
  nonWrapUpfrontFeeRules: normalizeNonWrapUpfrontFeeRules(),
  ...normalizeCommissionRateSettings(),
};

const InvestmentTransactionSettingsContext = createContext(DEFAULT_SETTINGS);

export const InvestmentTransactionSettingsProvider = ({ children }) => {
  const [api] = useServerApi();
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    let active = true;

    const loadSettings = async () => {
      try {
        const result = await api.search({
          apiEntity: "setting",
          pageSize: 1,
        });
        if (!active) return;
        const investmentTransaction = result?.docs?.[0]?.investmentTransaction;
        setSettings({
          nonWrapUpfrontFeeRules: normalizeNonWrapUpfrontFeeRules(
            investmentTransaction
          ),
          ...normalizeCommissionRateSettings(investmentTransaction),
        });
      } catch (error) {
        console.log(error);
      }
    };

    loadSettings();
    return () => {
      active = false;
    };
  }, []);

  const value = useMemo(
    () => settings,
    [
      settings.nonWrapUpfrontFeeRules,
      settings.nonWrapMaxSubscriptionFee,
      settings.onlineIfastCharge,
      settings.paperIfastCharge,
    ]
  );

  return (
    <InvestmentTransactionSettingsContext.Provider value={value}>
      {children}
    </InvestmentTransactionSettingsContext.Provider>
  );
};

export const useInvestmentTransactionSettings = () =>
  useContext(InvestmentTransactionSettingsContext);
